module.exports = __webpack_public_path__ + "media/images/pages/about/ncce_staff-1d5430b4230c2f2081d7eebb20b2ddc4.jpg";